import { ActionTypeReducer, GenStateType, NestedKeys } from "helpers/types";
import { UserModelGet } from "models/user_model";
import { EmpresaModel } from "models/empresa";
import { permissionStateForm, PermissionStateFormType } from "../../../../../helpers/permission";

type StateType = {
    loggedUser: UserModelGet;
    list: UserModelGet[];
    companyList: EmpresaModel[];
    user: UserModelGet;
    permission: PermissionStateFormType;
    loading: boolean;
    show: boolean;
    errorTitle: string;
    errorMsg: string;
    error: boolean;
    showDelete: boolean;
    showDeleteModal: boolean;
    userFormFieldsError: Partial<Record<NestedKeys<StateType["user"]>, string>>;
}

type ActionType = GenStateType<StateType>;

const initialState: StateType = {
    loggedUser: null,
    list: [],
    companyList: [],
    user: {
        id: '',
        nome: '',
        email: '',
        senha: '',
        nascimento: '',
        cpf: '',
        rg: '',
        dataAdmissao: '',
        pispasep: '',
        ctps: '',
        codigo: '',
        salario: '',
        idEmpresa: '',
        ativo: true,
        image: '',
        Permissao: [
            {
                id: '',
                idUsuario: '',
                item: '',
            }
        ],
        UsuarioContato: [
            {
               id: '',
               idUsuario: '',
               cargo: '',
               email: '',
               nome: '',
               principal: true,
               telefone: '',
            }
        ],
        UsuarioEndereco: [
            {
                id: '',
                idUsuario: '',
                cep: '',
                estado: '',
                cidade: '',
                bairro: '',
                local: '',
                numero: '',
                complemento: '',
                observacao: '',
                principal: true,
            }
        ],
    },
    permission: permissionStateForm(),
    loading: false,
    show: false,
    errorTitle: '',
    errorMsg: '',
    error: false,
    showDelete: false,
    showDeleteModal: false,
    userFormFieldsError: {
        id: '',
        nome: '',
        email: '',
        senha: '',
        nascimento: '',
        cpf: '',
        rg: '',
        dataAdmissao: '',
        pispasep: '',
        ctps: '',
        codigo: '',
        salario: '',
        idEmpresa: '',
        "UsuarioContato.cargo": '',
        "UsuarioContato.telefone": '',
        "UsuarioContato.email": '',
        "UsuarioContato.nome": '',
        "UsuarioEndereco.cep": '',
        "UsuarioEndereco.estado": '',
        "UsuarioEndereco.cidade": '',
        "UsuarioEndereco.bairro": '',
        "UsuarioEndereco.local": '',
        "UsuarioEndereco.numero": '',
        "UsuarioEndereco.complemento": '',
        "UsuarioEndereco.observacao": '',
    }
};

const reducer = (state: StateType, action: ActionTypeReducer<ActionType>) => {
    switch (action.type) {
        case "setList":
            return { ...state, list: action.payload };
        case "setCompanyList":
            return { ...state, companyList: action.payload };
        case "setUser":
            return { ...state, user: action.payload };
        case "setPermission":
            return { ...state, permission: action.payload };
        case "setLoading":
            return { ...state, loading: action.payload };
        case "setShow":
            return { ...state, show: action.payload };
        case "setErrorTitle":
            return { ...state, errorTitle: action.payload };
        case "setErrorMsg":
            return { ...state, errorMsg: action.payload };
        case "setError":
            return { ...state, error: action.payload };
        case "setShowDelete":
            return { ...state, showDelete: action.payload };
        case "setShowDeleteModal":
            return { ...state, showDeleteModal: action.payload };
        case "setLoggedUser":
            return { ...state, loggedUser: action.payload };
        case "setUserFormFieldsError":
            return { ...state, userFormFieldsError: action.payload };
        default:
            return state;
    }
}

export { initialState, reducer };
